// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__30AiB","avatar":"UserMenu_avatar__1WlOn","name":"UserMenu_name__A58A_"};